<template>
    <div class="container">
        <div class="header">
            <div class="header_title">
                <div style="width: 103px;"></div>
                <div class="title">
                    荷叶健康
                </div>
                <div class="right_icon">
                    <div class="msg" style="top: 23px; right: 74px;" @click="goInquiry">
                        <img src="../../icons/go_inquiry.png" style="margin-left: 9px;" />
                        <span class="text">去问诊</span>
                    </div>
                    <div style="width: 20px;"></div>
                    <div :class="['msg', { 'dot': messageCount }]" style="position: relative;" @click="goMessageList">
                        <img src="../../icons/home/tips.png" style="margin-left: 1px;" />
                        <span class="text">消息</span>
                    </div>
                    <div style="width: 20px;"></div>
                </div>
            </div>
        </div>
        <div class="header_search">
            <van-field class="search_input" v-model="userName" :center="true" left-icon="search" placeholder="搜索姓名"
                 bind:confirm="onSearch"/>
            <div class="header_text" @click="onSearch">搜索</div>
        </div>
        <div class="body">
            <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" :disabled="refreshDisabled"
                style="height: 100%;">
                <van-list v-show="list.length > 0" v-model="loadLoading" :finished="loadFinished" :offset="20" :immediate-check="false"
                    finished-text="没有更多了" @load="onLoad" class="list">
                    <CardItem v-for="(item, index) in list" :key="index" :cardInfo="item" :thirdPartyPlatformName="thirdPartyPlatformName" :thirdPlatformSource="thirdPlatformSource" 
                         @deleteFn="currentDeleteFn" />
                    <div style="height: 20px;"></div>
                </van-list>
                <div v-show="list.length < 1 && !createLoading" style="display: flex; height: 500px; justify-content: center; align-items: center;">
                    暂无待问诊信息!
                </div>
            </van-pull-refresh>


        </div>
    </div>
</template>
<script>
import {
    getNoreadMessage,
    checkIfOpen,
    physicanStatus,
    checkBtermInquiryPermission,

} from '../../api/index'
import {
    getPrePrescriptionList,
    deletePrePrescriptionById,
    getThirdPartyPlatformCode,
} from '../../api/haidian'
import CardItem from './components/cardItem.vue'
import { Toast } from 'vant'
import { getCookie } from '@/utils/auth'
export default {
    components: {
        CardItem
    },
    data() {
        return {
            organSign: '',
            thirdPartyPlatformCode:'',
            thirdPartyPlatformName:'',
            thirdPartyPlatformIcon:'',
            thirdPlatformSource:'',
            userName:'',
            messageCount: 0,
            // 是否刷新中
            refreshLoading: false,
            // 是否禁用刷新
            refreshDisabled: false,
            // 是否加载中
            loadLoading: false,
            // 数据是否加载完毕
            loadFinished: false,
            // 初次加载loading
            createLoading:false,
            scrollTop: 0,
            pageSize:10,
            pageNum:1,
            total:0,
            // 
            list: []
        }
    },
    computed: {
    },
    beforeDestroy() {
    },
    created() {
        this.createLoading = true
        const client = getCookie('native_client') || ''
        if (client === 'android' || client === 'ios' || client === 'pad') {
            this.organSign = getCookie('native_organSign')
        } else {
            this.organSign = getCookie('organSign')
        }
        setTimeout(() => {
            window.location.href = `protocol://action/showBottomTab`
        }, 500)
        this.init();
        
    },
    watch: {
        scrollTop(newval) {
            if (newval > 0) {
                this.refreshDisabled = true
            } else {
                this.refreshDisabled = false
            }
        }
    },
    mounted() {
        this.resolveConflict()
    },
    beforeDestroy() {
        const el = document.querySelector('.van-list')
        if (el) {
            el.removeEventListener('scroll', () => { })
        }
    },
    methods: {
        async onSearch() {
            console.log(this.userName);
            this.pageSize = 10;
            await this.pageQuery()
            const el = document.querySelector('.van-list')
            el.scrollTop = 0
        },
        async pageQuery() {
            let body = {
                thirdPartyPlatformCode:this.thirdPartyPlatformCode,
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                userName:this.userName,
            }
            let res = await getPrePrescriptionList(body)
            if (res.code == 0) {
                this.list = res.result.list || [];
                this.total = res.result.total;
                if (this.pageSize == this.total) {
                    this.loadFinished = true
                }else {
                    this.loadFinished = false
                }
            }
            console.log('----bug 111111');
            this.createLoading = false
        },
        resolveConflict() {
            this.$nextTick(() => {
            const el = document.querySelector('.van-list')
                el.addEventListener('scroll', () => {
                        this.scrollTop = el.scrollTop
                })
            })
        },
        async currentDeleteFn(value) {
            try {
                let res = await deletePrePrescriptionById({thirdPartyPrePrescriptionId:value.id})
                if (res.code == 0) {
                    Toast('删除成功');
                    this.pageQuery()
                }else {
                    Toast(res.msg || '删除失败');
                }
            } catch (error) {
                Toast(error.msg || '删除失败');
            }
        },
        // 下拉刷新
        async onRefresh() {
            this.refreshLoading = true;
            this.loadFinished = false
            console.log('下拉刷新哦😯');
            this.pageSize = 10;
            await this.pageQuery()
            this.refreshLoading = false;
        },
        // 滚动加载
        async onLoad() {
            this.refreshDisabled = true
            this.loadLoading = true
            console.log('滚动加载哦😯');
            this.pageSize += 10;
            if (this.pageSize > this.total) {
                this.pageSize = this.total
            }
            await this.pageQuery()
            this.loadLoading = false
            if (this.pageSize == this.total) {
                this.loadFinished = true
            }
            console.log('----bug 222222');
        },
        async init() {
            let re = await getThirdPartyPlatformCode()
            if (re.code == 0 && re.result.thirdPartyPlatformCode != undefined && re.result.thirdPartyPlatformCode != '') {
                this.thirdPartyPlatformCode = re.result.thirdPartyPlatformCode
                this.thirdPartyPlatformName = re.result.thirdPartyPlatformName
                this.thirdPlatformSource =  re.result.thirdPlatformSource
                this.thirdPartyPlatformIcon =  re.result.thirdPartyPlatformIcon
            }
            const res = await getNoreadMessage({ organSign: this.organSign })
            this.messageCount = res.result
            this.pageQuery();
        },
        goMessageList() {
            if (this.messageCount) {
                this.$store.dispatch('getnews', 'clear')
            }
            this.$router.push({ path: 'news' })
        },
        async goInquiry() {
            var permission = await checkBtermInquiryPermission({ organSign: this.organSign });
            if (permission.data.code === 0) {
                if (!permission.data.result.passable) {
                    return Toast(permission.data.result.tipMessage);
                }
            } else {
                return Toast(permission.data.msg);
            }
            localStorage.removeItem('params')
            try {
                physicanStatus({ organSign: this.organSign }).then(res => {
                    if (res.data.code === 0) {
                        // 1-有医生在线；0-无医生在线；
                        if (res.data.result.doctorOnlineState) {
                            checkIfOpen({ organSign: this.organSign }).then(res => {
                                if (res.result !== false) {
                                    localStorage.setItem('sourceId','0')
                                    let page = 'interrogationInfoText';
                                    this.$router.push(page)
                                } else {
                                    Toast(
                                        '您还未开通远程处方服务，如需开通请联系客服电话400-0919-990'
                                    )
                                }
                            })
                        } else {
                            Toast(this.res.data.result.desc)
                        }
                    } else {
                        Toast(this.res.data.result.desc)
                    }
                })
            } catch (err) {
                this.setLog({
                    message: '获取医生状态接口异常',
                    type: '/home'
                })
                console.log('err', err)
            }
        },
    }
}
</script>
<style scoped lang="scss">
.container {

    width: 100%;
    height: 100vh;
    background-color: #EEEEEE;
}

.header {
    height: 69.5px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #EEEEEE;
}

.header_title {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
    }

    .right_icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .msg {
        text-align: center;

        img {
            display: block;
            width: 19px;
            height: 19px;
        }

        &.dot {
            &:before {
                content: '';
                position: absolute;
                width: 6px;
                height: 6px;
                background: #fa5523;
                border-radius: 50%;
                right: 0;
                top: -3px;
            }
        }

        .text {
            display: block;
            font-weight: 400;
            font-size: 11px;
            color: #41435D;
            letter-spacing: 0;
        }
    }
}

.header_search {
    height: 55px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;

    .search_input {
        width: 309px;
        height: 30px;
        background: #F5F6FA;
        border-radius: 18px;
        line-height: 30px
    }

    .header_text {
        font-size: 15px;
        color: #111334;
        margin-left: 10px;
    }
}

.body {
    height: 80%;

    .list {
        padding: 12px;
        min-height: 400px;
        height: 100%;
        background-color: #EEEEEE;
        overflow: auto;
    }
}
</style>